import { useDispatch } from "react-redux"
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { setActiveProduct } from "src/features/checkout/checkoutSlice"
import { DEFAULT_PRODUCT_IMAGE } from "src/app/constants"
import { currencyFormat } from "src/app/utils"
import useAddToCart from "src/app/hooks/useAddToCart"

export function AddonItem({ addon }) {
  const dispatch = useDispatch()
  const [addToCart, { isLoading }] = useAddToCart()

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <CardActionArea onClick={() => dispatch(setActiveProduct(addon))}>
        <CardMedia
          sx={{
            paddingTop: "56.25%",
            backgroundSize: "contain",
          }}
          image={addon.images.edges[0]?.node.url || DEFAULT_PRODUCT_IMAGE}
          title={addon.images.edges[0]?.node.altText || ""}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="body2">{addon.title}</Typography>
          <Typography variant="body1">
            {currencyFormat(addon.variants.edges[0].node.price.amount)}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions
        sx={{
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
        }}
      >
        <LoadingButton
          loading={isLoading}
          disabled={isLoading}
          variant="text"
          size="small"
          sx={{ mb: 2 }}
          onClick={() => addToCart(addon)}
        >
          Add to Cart
        </LoadingButton>
      </CardActions>
    </Card>
  )
}
